import { render, staticRenderFns } from "./ThermalModuleTestDataAnalysis.vue?vue&type=template&id=2c2a804d"
import script from "./ThermalModuleTestDataAnalysis.vue?vue&type=script&lang=js"
export * from "./ThermalModuleTestDataAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports